/** True when the event target is a field where typing should not be interrupted. */
export function isEditableKeyboardTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
    return true;
  }
  if (target.isContentEditable) {
    return true;
  }
  return Boolean(target.closest('[contenteditable="true"]'));
}

/** Alt+Shift+L (Option+Shift+L on macOS) — avoids Ctrl/Meta conflicts with browser shortcuts. */
export function isLanguageToggleShortcut(event: KeyboardEvent): boolean {
  if (event.defaultPrevented || event.isComposing) {
    return false;
  }
  if (event.ctrlKey || event.metaKey) {
    return false;
  }
  if (!event.altKey || !event.shiftKey) {
    return false;
  }
  return event.key.toLowerCase() === 'l';
}
